import { SubmitHandler, useForm } from "react-hook-form";
import { Box, Button } from "@mui/material";

import { formConfig } from "./formConfig";
import { reasonOptions } from "./reasonOptions";

import DropdownInput from "@/components//RHFcomponents/DropdownInput";
import Field from "@/components/RHFcomponents/Field";
import TextArea from "@/components/RHFcomponents/TextArea";
import { postContacts } from "@/api/postContacts";
import { useState, useRef } from "react";
import Notification from "@/components/Notification/Notification";
import Captcha, { CaptchaRef } from "@/components/Captcha/Captcha";

const ContactUsForm = () => {
  const [notificationIsOpen, setNotificationIsOpen] = useState(false);
  const [captchaValid, setCaptchaValid] = useState<ICaptchaValid>({
    valid: false,
    value: "",
  });

  const captchaRef = useRef<CaptchaRef>(null);
  const handleCaptchaVerify = (captcha: ICaptchaValid) => {
    setCaptchaValid(captcha);
  };

  // Form control using React Hook Form
  const { handleSubmit, control, reset } = useForm<IContactFields>(formConfig);

  const onSubmit: SubmitHandler<IContactFields> = async (data) => {
    if (captchaValid.valid) {
      const response = await postContacts(data, captchaValid);
      reset();
      captchaRef.current?.resetCaptcha();

      if (response?.status === 200) {
        setNotificationIsOpen(true);

        setTimeout(() => {
          setNotificationIsOpen(false);
        }, 2500);
      }
    }
  };

  return (
    <>
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        gap={{ xs: 2, md: 3 }}
        display="flex"
        flexDirection="column"
      >
        <Box
          display="flex"
          justifyContent="space-between"
          gap={{ xs: 2, md: 3 }}
        >
          <Field
            name="firstName"
            control={control}
            placeholder="Your first name"
          />
          <Field
            name="lastName"
            control={control}
            placeholder="Your last name"
          />
        </Box>
        <Field name="email" control={control} placeholder="Your email" />

        <DropdownInput
          name="reason"
          control={control}
          options={reasonOptions}
          placeholder="How we can help?"
        />

        <TextArea name="message" control={control} placeholder="Message" />
        <Captcha onVerify={handleCaptchaVerify} ref={captchaRef} />
        <Button
          variant="contained"
          type="submit"
          sx={{ mt: { xs: 2, md: 0 } }}
          disabled={!captchaValid.valid}
        >
          Get in touch
        </Button>
      </Box>

      <Notification
        open={notificationIsOpen}
        onClose={() => setNotificationIsOpen(false)}
        title="Contact form has been sent successfully "
      />
    </>
  );
};

export default ContactUsForm;
